<template>
  <!-- gk-list-item{*} -->
  <div class="item-content">
    <div class='item' @mouseenter="onMouseOver()" @mouseleave="onMouseOut()" v-if="index==='head'" :style="{background: currColor}">
      <div class="mask">
        <div class="item-rank" v-for="(value, key, index) in item" :key='index' 
          :style="{'font-weight': 'bold'}" @click="sort(key)"
        >{{key}}</div>
      </div>
      {{load}}
    </div>
    <div class='item' @mouseenter="onMouseOver()" @mouseleave="onMouseOut()" v-if="index!=='head'" :style="{background: currColor}" @click="onClick">
      <div class="mask">
        <div class="item-rank" v-for="(value, key) in order" :key='key'>{{item[key]}}</div>
      </div>
      {{load}}
    </div>
    <div class="item-box">
      <check-box v-if="index !== 'head'&&box" :item="[item]"></check-box>
      <check-box v-if="index === 'head'&&box" :item="items"></check-box>
    </div>
  </div>
</template>

<script>
  import CheckBox from '@/components/CheckBox'
  export default {
    props: ['item', 'index', 'items', 'box', 'order'],
    components: {
      CheckBox
    },
    data () {
      return {
        defaltColor: '',
        activeColor: 'rgb(82, 82, 82)', 
        currColor: ''
      }
    },
    created () {
    },
    computed: {
      load () {
        if (this.index === 'head') {
          this.defaltColor = 'rgb(82, 82, 82)'
        } else {
          this.defaltColor = this.index % 2 === 0 ? 'rgb(53, 53, 53)' : 'rgb(61, 61, 61)'
        }
        this.currColor = this.defaltColor
      }
    },
    methods: {
      onMouseOver () {
        this.currColor = this.activeColor
      },
      onMouseOut () {
        this.currColor = this.defaltColor
      },
      onClick () {
        if (this.box) this.$store.commit('CLICK_LIST_ITEM', [this.item])
      },
      sort(key) {
        let data = {
          oper: 'sort',
          from: 'listItem',
          key: key 
        }
        this.$emit('childOper', data);
      }
    }
  }
</script>
<style scoped>

  .item-content {
    display: flex;
    flex-direction: row;
    background-color: #fff;
  }

  .item {
    /* width: calc(100% - 29px); */
    padding: 13px 20px;
    /* margin: 3px 0 0 0; */
    flex-grow: 1;
  }

  .mask {
    height: 16px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    /* position: relative;
    left:0px;
    top:0px; */
  }

  .item-rank {
    margin: 0 20px;
    overflow-x: auto;
    overflow-y: hidden;
    line-height:16px;
    font-size: 16px;
    color: rgb(200, 200, 200);
    flex-grow: 1;
    width:0;
  }

  .item-box {
    height: 26px;
    width: 26px;
    margin: 2px 0 0 2px;
    margin-right: 16px;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/ListItem.vue